export default {
    somethingWrong: 'เกิดข้อผิดพลาด!!',
    close: 'ปิด'
}
